import React from 'react'
import { Field } from 'redux-form'
import Form from './form/Form'
import CustomSelectField from './form/CustomSelectField'

export const LanguageSwitcher = props => {

	return <Form {...props}>
		<Field
			name='lang'
			component={CustomSelectField}
			className='u-margin-horizontal'
			options={[
				{ value: 'bg', label: 'BG' },
				{ value: 'en', label: 'EN' },
				{ value: 'ru', label: 'RU' }
			]}
			/>
	</Form>
}

export default LanguageSwitcher



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.js